import { render, staticRenderFns } from "./RxForm.vue?vue&type=template&id=0ee98a9e"
import script from "./RxForm.vue?vue&type=script&lang=js"
export * from "./RxForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports